import React from 'react'
import styled from 'styled-components'
import colors from '../../../styles/colors'

const NumBox = ({ className, mainTitle, title, num, unit }) => {
  return (
    <NumWrap className={className}>
      {mainTitle && <MainTit>{mainTitle}</MainTit>}
      {mainTitle ? <SubTit>{title}</SubTit> : <NumTit>{title}</NumTit>}
      <NumUnit>
        <NumTxt className="">{String(num)}</NumTxt>
        {unit}
      </NumUnit>
    </NumWrap>
  )
}

export default NumBox

const NumWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  text-align: center;
  flex: 1 0;
`

const NumWrapper = styled.div`
  flex: 1 0;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
    flex: 0 0 auto;
    width: 50%;
    margin-bottom: 15px;
  }
`

const MainTit = styled.h4`
  color: ${colors.BK};
  font-size: 18px;
  margin-bottom: 15px;
  @media screen and (max-width: 800px) {
    font-size: 16px;
  }
  @media screen and (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 10px;
  }
`
const SubTit = styled.h4`
  color: #767676;
  font-size: 16px;
  margin-bottom: 15px;
  @media ${(props) => props.theme.mobile} {
    font-size: 12px;
    margin-bottom: 10px;
  }
`

const NumTit = styled.h4`
  color: ${colors.BK};
  font-size: 16px;
  margin-bottom: 15px;
  @media ${(props) => props.theme.mobile} {
    font-size: 12px;
    margin-bottom: 10px;
  }
`
const NumUnit = styled.p`
  max-width: 60px;
  color: #000;
  font-size: 16px;
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const NumTxt = styled.span`
  color: ${colors.BK};
  font-size: 22px;
  font-weight: 700;
  margin-right: 2px;
`
